/**
 * The app's button finish, by name. The finish itself is defined once, in index.css (`.sleek-*`); these name it for
 * buttons that write their own classes, so changing a finish there changes every button. Shape and size stay the
 * caller's.
 */
/** The neutral (secondary) button: the control's finish on the page's own ground. */
export const BUTTON_SECONDARY = "sleek-control sleek-press bg-body dark:bg-body-100";

/** The primary button: the same finish on the primary green (trueBlack text). */
export const BUTTON_PRIMARY = "sleek-green sleek-press";

/** The ink button (the send button's: dark in light mode, light in dark). */
export const BUTTON_INK = "sleek-ink sleek-press";
